import { useRef } from 'react'
import { useSelector } from 'react-redux'
import { Block } from '../../../components/UI/Contents'
import { Formik, Form } from 'formik'
import * as Yup from 'yup'

// Components
import { ActionsRow, Container, ErrorText, ForgotPassword, FormBody, FormField, SecondaryAction } from './styled'
import { Button } from '../../../components/UI/Buttons'
import Input from '../../UI/TextInput'
import { useTranslation } from 'react-i18next'

const SignInSchema = Yup.object().shape({
  password: Yup.string()
    .min(5, '¡La contraseña es muy corta!')
    .max(50, '¡La contraseña es muy larga!')
    .required('¡La contraseña es requerida!'),
  email: Yup.string().email('¡El correo no es válido!').required('¡El correo es requerido!'),
})

interface IProps {
  onSubmit: (values: any) => void
}

// MAIN
/**
 * @description Componente formulario de login
 */
const LoginForm = (props: IProps) => {
  const { t } = useTranslation()

  const { onSubmit } = props
  const loading = useSelector((state: any) => state.user.loading)

  const initialValues = useRef({
    email: '',
    password: '',
  })

  const handleSubmit = (values: any): void => {
    onSubmit(values)
  }
  return (
    <Container>
      <Formik validationSchema={SignInSchema} onSubmit={handleSubmit} initialValues={initialValues.current}>
        {({ errors, touched, values, handleChange, isValid }) => (
          <Form style={{ width: '100%' }}>
            <FormBody>
              <FormField>
                <Input
                  value={values.email}
                  onChange={handleChange('email')}
                  type="text"
                  name="email"
                  label={t('global.common.loginEmailText')}
                />
                {errors.email && touched.email ? (
                  <div>
                    <ErrorText>{errors.email}</ErrorText>
                  </div>
                ) : null}
              </FormField>
              <FormField>
                <Input
                  value={values.password}
                  onChange={handleChange('password')}
                  type="password"
                  name="password"
                  label={t('global.common.loginPasswordText')}
                  error={errors.password && touched.password ? true : false}
                />
                {errors.password && touched.password ? (
                  <div>
                    <ErrorText>{errors.password}</ErrorText>
                  </div>
                ) : null}
              </FormField>
              <ActionsRow>
                <SecondaryAction>
                  <ForgotPassword href="/forgot">{t('global.common.forgotPasswordButton')}</ForgotPassword>
                </SecondaryAction>
                <Block width="100%">
                  <Button
                    fullWidth
                    disabled={!isValid || loading}
                    type="submit"
                    size="lg"
                  >
                    {loading ? 'Ingresando...' : t('global.common.loginButton')}
                  </Button>
                </Block>
              </ActionsRow>
            </FormBody>
          </Form>
        )}
      </Formik>
    </Container>
  )
}

export default LoginForm
